import { gql } from '@apollo/client';

export default gql`
  mutation updatePCategory(
    $_id: String
    $branch: String
    $name: String
    $nameAr: String
    $disabled: Boolean
    $additionId: String
  ) {
    updatePCategory(
      _id: $_id
      branch: $branch
      name: $name
      nameAr: $nameAr
      disabled: $disabled
      additionId: $additionId
    ) {
      ok
      message
      data
      error
    }
  }
`;
